<template>
  <div class="content">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-12 px-0">
          <top-navbar :title="restaurantName" search="false"></top-navbar>
        </div>
        <div class="col-md-10 offset-md-1 col-12 text-center" style="margin-top: 2rem">

          <div class="row">
            <div class="col-md-4">
              <sidebar-link to="/admin/owner-list" style="list-style-type: none;">
                <button class="btn backBtn">
                  Back
                </button>
              </sidebar-link>
            </div>
            <div class="col-md-4">
              <h3 class="font-weight-bold d-inline-block">Support</h3>
            </div>
            <div class="col-md-4">
              <button class="btn backBtn" @click="goToRestDashboard">
                Dashboard
              </button>
            </div>
            <div class="col-md-6 offset-md-3 px-5">
              <div>
                <label class="font-weight-bold float-left">Name</label>
                <p v-if="notedByError" style="color: red; margin-bottom: 5px;">{{ notedByError }}</p>
                <input type="text" class="form-control" v-model="notedBy" placeholder="Enter Name" style="border: 1px solid;">
              </div>
              <div>
                <label class="font-weight-bold float-left mt-3">Note</label>
                <p v-if="noteError" style="color: red; margin-bottom: 5px;">{{ noteError }}</p>
                <textarea class="form-control" v-model="note" placeholder="Enter Note" style="border: 1px solid;"></textarea>
              </div>
              <div class="d-flex justify-content-end mt-3">
                <button @click="addNote" :disabled="isAddingNote" class="btn submitBtn">
                  {{ isAddingNote ? 'Saving...' : 'Save' }}
                </button>
              </div>
            </div>
          </div>

          <div class="row mt-4 pb-5">
            <div class="col-md-6 offset-md-3 px-5">
              <div v-for="(note, i) in restData.notes" :key="i">
                <p class="font-weight-bold text-left">{{ note.name }}</p>
                <div style="width: 70%; display: flex; justify-content: space-between;">
                  <p><b>Note:</b></p>
                  <p>{{ note.date }}</p>
                  <p>{{ note.time }}</p>
                </div>
                <p class="text-center">{{ note.note }}</p>
                <hr v-if="i < restData.notes.length - 1" style="border: 1px solid;">
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import TopNavbar from '../../layout/TopNavbar'
  import axios from 'axios'

  export default {
    components: {
      TopNavbar
    },
    data () {
      return {
        restaurantName: localStorage.getItem('restaurantName'),
        notedBy: '',
        note: '',
        notedByError: '',
        noteError: '',
        isAddingNote: false,
        restData: ''
      }
    },
    mounted() {
      this.getRestaurantData()
    },
    methods: {
      getRestaurantData(){
        let url = process.env.VUE_APP_API_URL+'/api/restaurant/find?id='+localStorage.getItem('restaurantId')
        axios
          .get(url, {headers: {Authorization: `Bearer ${this.$cookies.get('token')}`}})
          .then((result) => {
            this.restData = result.data
          })
      },
      addNote () {
        this.notedByError = ''
        this.noteError = ''

        if (!this.notedBy.trim()) {
          this.notedByError = 'Name is required'
          return
        }
        if (!this.note.trim()) {
          this.noteError = 'Note is required'
          return
        }

        this.isAddingNote = true

        let now = new Date()
        let date = now.getDate().toString().padStart(2, '0') + '/' + (now.getMonth() + 1).toString().padStart(2, '0') + '/' +  now.getFullYear()
        let hours = now.getHours()
        let ampm = hours >= 12 ? 'PM' : 'AM'
        hours = hours % 12
        hours = hours ? hours : 12
        let time = hours.toString().padStart(2, '0') + ':' + now.getMinutes().toString().padStart(2, '0') + ' ' + ampm

        let newNote = {
          name: this.notedBy,
          note: this.note,
          date: date,
          time: time
        }

        if (!this.restData.notes) {
          this.restData.notes = []
        }
        this.restData.notes.push(newNote)

        let url = process.env.VUE_APP_API_URL + '/api/restaurant/update'
        let tempDetails = { ...this.restData }

        axios
          .post(url, tempDetails, {
            headers: {
              Authorization: `Bearer ${this.$cookies.get('token')}`,
            }
          })
          .then((data) => {
            this.$toastr.s("Note Added Successfully", "Success");
            this.notedBy = ''
            this.note = ''
            this.isAddingNote = false

            if (data.status === 403) {
              let logoutResponse = this.logout()
              if (logoutResponse === 1) {
                this.$router.push({ path: '/login' })
              }
            }
          })
          .catch(() => {
            // Revert the note addition on error
            this.restData.notes.pop()
            this.isAddingNote = false
          })
      },
      goToRestDashboard () {
        this.$router.push('/admin/owner-dashboard')
      },
    }
  }

</script>
<style scoped>

</style>
